import { artifactFileName } from '../fileMedia.js';
import { starscribeApi } from './api.js';
/** How long a saved file's object URL is kept for the download to start (GeneratedFiles.tsx keeps it as long). */
const DOWNLOAD_URL_MS = 60_000;
/**
 * An exported page, saved as the chat's "Generated files" save a file (GeneratedFiles.tsx): its bytes from gyro-svc with this
 * surface's sign-in (GET /v1/artifacts/<task>/<file>), an inert type so it never renders in the page, a safe file name, and
 * the browser's download, which the desktop app's window saves as it saves every generated file.
 */
export async function saveStarscribeArtifact(client, artifact) {
    if (artifact.source === 'desktop')
        throw new Error('This file is no longer available. Export the page again.');
    const blob = await client.downloadArtifact(artifact);
    const url = URL.createObjectURL(new Blob([blob], { type: 'application/octet-stream' }));
    const link = document.createElement('a');
    link.href = url;
    link.download = artifactFileName(artifact.name);
    link.rel = 'noopener';
    document.body.append(link);
    link.click();
    link.remove();
    setTimeout(() => URL.revokeObjectURL(url), DOWNLOAD_URL_MS);
}
const apis = new WeakMap();
/** The one StarScribe API of a client: made the first time a page of that client opens, the same object after. */
export function starscribeApiFor(client) {
    const known = apis.get(client);
    if (known)
        return known;
    const api = starscribeApi({
        request: (path, options) => client.starscribeRequest(path, options),
        events: (path, options) => client.starscribeEvents(path, options),
        blob: (path, options) => client.starscribeBlob(path, options),
        // The answer is checked by api.ts (uploadImage) before the page uses its src.
        upload: (path, body, contentType) => client.starscribeUpload(path, body, contentType),
        saveArtifact: (artifact) => saveStarscribeArtifact(client, artifact),
    });
    apis.set(client, api);
    return api;
}
//# sourceMappingURL=transport.js.map